module.exports = __webpack_public_path__ + "img/灵活开放的推荐平台化能力.0735ac9a.png";